// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@west/App/SharedStyles/CartLineSharedStyles";
import { cartLineCardExpandedStyles } from "@west/Overrides/Widgets/Cart/CartLineCardExpanded";
import { xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

cartLineCardExpandedStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

cartLineCardExpandedStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

cartLineCardExpandedStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

cartLineCardExpandedStyles.productNonReturnableMessage = {
    ...cartLineSharedStyles.productNonReturnableMessage,
};

cartLineCardExpandedStyles.productPrice = {
    ...cartLineSharedStyles.productPrice,
};

cartLineCardExpandedStyles.extendedUnitNetPriceHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

cartLineCardExpandedStyles.removeCartLineIcon = {
    ...cartLineSharedStyles.removeCartLineIcon,
};

cartLineCardExpandedStyles.addToListLink = {
    ...cartLineSharedStyles.addToListLink,
};

cartLineCardExpandedStyles.configurationGridItem = {
    ...cartLineSharedStyles.configurationContainer,
};

cartLineCardExpandedStyles.configurationOptionText = {
    ...cartLineSharedStyles.configurationOptionText,
};

cartLineCardExpandedStyles.deliveryScheduleButton = {
    css: css`
        align-self: baseline;
        width: auto;
    `,
};

cartLineCardExpandedStyles.promotionNameText = {
    ...cartLineSharedStyles.promotionNameText,
};

cartLineCardExpandedStyles.costCodeGridItem = {
    ...cartLineSharedStyles.costCodeGridItem,
};

cartLineCardExpandedStyles.costCodeLabelText = {
    ...cartLineSharedStyles.costCodeLabelText,
};

cartLineCardExpandedStyles.costCodeText = {
    ...cartLineSharedStyles.costCodeValueText,
};

cartLineCardExpandedStyles.productAvailability = {
    ...cartLineSharedStyles.productAvailability,
};

cartLineCardExpandedStyles.cartLineErrorMessageGridItem = {
    ...cartLineSharedStyles.cartLineErrorMessageGridItem,
};

cartLineCardExpandedStyles.cartLineErrorMessageText = {
    ...cartLineSharedStyles.errorMessage,
};

cartLineCardExpandedStyles.cartLineNotes = {
    ...cartLineSharedStyles.cartLineNotes,
};

cartLineCardExpandedStyles.extendedUnitNetPriceWrapper = {
    css: css`
        display: flex;
        align-items: center;
        ${xScreen("lt", "sm")} {
            align-items: end;
        }
    `,
};

cartLineCardExpandedStyles.costCodeSelect = {
    cssOverrides: {
        formField: css`
            width: 200px;
        `,
    },
};

cartLineCardExpandedStyles.realTimePricingFailureText = {
    weight: "bold",
    size: 14,
};
cartLineCardExpandedStyles.quantity = {
    editableQuantityTextField: {
        errorProps: {
            mergeCss: true,
            css: css`
                width: 150px;
            `,
        },
    },
};
